import getComponent from '../utils/get-component'

export default getComponent('page')
